module.exports = __webpack_public_path__ + "img/6.png.9b9e9076.webp";